// native
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

// addon
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

// service
import { TestsService } from '../../core/services/tests.service';
import { TestBundlesService } from 'app/core/services/test-bundles.service';
import { PreferencesService } from 'app/core/services/preferences.service';
import { MonitorTestService } from 'app/core/services/monitor-test.service';
import { DevicesService } from 'app/core/services/devices.service';
import { AuthService } from 'app/core/services/auth.service';
import { PatientsService } from 'app/core/services/patients.service';
import { StreamingService } from 'app/core/services/streaming.service';
import { DialogService } from 'app/core/services/dialog.service';

// component
import { MonitorBaseComponent } from '../monitor-base.component';

// models
import { AcuityOptotypeRecord, MonitorEvent } from '../../models';

//animation
import { fadeAnimation, startList } from '../../animations/animations';

// constant
import { MONITOR_EVENT_TYPE, MONITOR_INACTIVITY_TIMEOUT } from '../../constants';

@Component({
    selector: 'app-monitor-functional-vision',
    templateUrl: './monitor-functional-vision.component.html',
    animations: [fadeAnimation, startList],
    standalone: false
})
export class MonitorFunctionalVisionComponent extends MonitorBaseComponent {

  eyeData: AcuityOptotypeRecord[] = [];

  ongoingPercentage: number;

  isLoading: boolean = true;
  inactivityTimeout = MONITOR_INACTIVITY_TIMEOUT.VISUAL_ACUITY * 1000;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public testService: TestsService,
    public testBundlesService: TestBundlesService,
    public toastService: ToastrService,
    public devicesService: DevicesService,
    public authService: AuthService,
    public patientsService: PatientsService,
    public monitorTestService: MonitorTestService,
    public streamingService: StreamingService,
    public preferencesService: PreferencesService,
    public translateService: TranslateService,
    public dialogService: DialogService) {
    super(route, router, testService, testBundlesService, toastService, devicesService, authService, patientsService,
      monitorTestService, streamingService, preferencesService, translateService, dialogService);
  }

  public getCurrentTestState() {
    this.monitorTestService.getAcuityState(this.test.id)
      .pipe(
        finalize(() => this.isLoading = false)
      ).subscribe(records => {
        this.renderRecords(records);
      });

    this.monitorTestService.getProgress(this.test.id).subscribe(progress => {
      this.ongoingPercentage = progress;
    });
  }

  private renderRecords(records: AcuityOptotypeRecord[]) {
    // we are showing all the recieved records, there is no filtering by eye
    records.forEach(record => {
      this.eyeData[record.seq_num - 1] = record;
    });
  }

  public getPercentageDone() {
    return this.isTestDone
      ? 100
      : this.ongoingPercentage;
  }

  public calculateDimensions() { }

  public handleNewRecordEvent(event: MonitorEvent) {
    if (event.type === MONITOR_EVENT_TYPE.NEW_ACUITY_RECORD)
      this.updateRecords(<AcuityOptotypeRecord>event.data);

    if (event.type === MONITOR_EVENT_TYPE.PROGRESS_UPDATE_RECORD) {
      this.ongoingPercentage = <number>event.data;
    }
  }

  private updateRecords(record: AcuityOptotypeRecord) {
    this.eyeData[record.seq_num - 1] = record;
  }

  isRecordHidden(record: AcuityOptotypeRecord, index: number) {
    const firstOptotype = this.eyeData.find(x => !!x);
    if (!firstOptotype)
      return false;

    return index > this.eyeData.length - firstOptotype.seq_num;
  }

  public resetStateAfterReconnection(): void {
    this.eyeData = [];
  }

  public onToggleGrid() { }
}